import React from 'react';
const withStylableSupport = (Component, compClassName) => class WithStylableSupport extends React.Component {
  render() {
    const {
      internalOrExternal,
      ...props
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%'
      },
      className: `${compClassName}-${internalOrExternal}`
    }, /*#__PURE__*/React.createElement(Component, props));
  }
};
export default withStylableSupport;
//# sourceMappingURL=withStylableSupport.js.map